/**
 * BILL permission codes used by the web. Mirrors `definePermissions('bill', …)`
 * in api/src/modules/bill/permissions.ts.
 */
export const P = {
  quotation: { read: 'bill.quotation.read', manage: 'bill.quotation.manage' },
  invoice: {
    read: 'bill.invoice.read',
    create: 'bill.invoice.create',
    issue: 'bill.invoice.issue',
    revise: 'bill.invoice.revise',
    cancel: 'bill.invoice.cancel',
    purge: 'bill.invoice.purge',
    export: 'bill.invoice.export',
  },
  report: { read: 'bill.report.read' },
} as const;

/** Permissions of other modules the billing screens link to (links are hidden without them). */
export const EXT = {
  customerRead: 'core.customer.read',
  companyRead: 'core.company.read',
  fxRateRead: 'core.fx_rate.read',
  receiptCreate: 'fin.receipt.create',
  arRead: 'fin.ar.read',
  einvoiceRead: 'tax.einvoice.read',
  egsRead: 'tax.egs.read',
} as const;

/** Sales dashboard (`GET /bill/dashboard`). */
export const DASHBOARD = [P.report.read, P.invoice.read];
